if (!customElements.get('caene-home-gallery')) {
  customElements.define('caene-home-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      const track = this.querySelector('.caene-home-products__images');
      if (!track || !track.children.length) return;
      const progress = this.querySelector('.caene-home-products__progress span');
      const count = track.children.length;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      let width = track.clientWidth;
      let index = Math.min(count - 1, Math.max(0, Math.round(track.scrollLeft / (width || 1))));
      let target = null;
      const updateProgress = () => {
        if (progress) progress.style.transform = `translateX(${index * 100}%)`;
      };
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        index = ((target ?? index) + Number(button.dataset.step) + count) % count;
        target = index;
        track.scrollTo({left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal}));
      track.addEventListener('scroll', () => {
        // ResizeObserver restores the saved slide before accepting new offsets.
        if (!width || track.clientWidth !== width || target !== null) return;
        index = Math.min(count - 1, Math.max(0, Math.round(track.scrollLeft / width)));
        updateProgress();
      }, {passive: true, signal});
      track.addEventListener('scrollend', () => {
        if (track.clientWidth !== width) return;
        target = null;
        index = Math.min(count - 1, Math.max(0, Math.round(track.scrollLeft / (width || 1))));
        updateProgress();
      }, {signal});
      this.observer = new ResizeObserver(() => {
        const nextWidth = track.clientWidth;
        if (!nextWidth || nextWidth === width) return;
        index = target ?? index;
        target = null;
        width = nextWidth;
        track.scrollTo({left: index * width, behavior: 'instant'});
        updateProgress();
      });
      this.observer.observe(track);
      updateProgress();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

if (!customElements.get('caene-product-feed')) {
  customElements.define('caene-product-feed', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const track = this.querySelector('.caene-home-products');
      const cards = [...track.children];
      if (!cards.length) return;
      const controls = this.querySelector('.caene-product-feed__controls');
      const buttons = [...controls.querySelectorAll('button')];
      const count = controls.querySelector('.caene-product-feed__count');
      const mobile = matchMedia('(max-width:749px)');
      const motion = matchMedia('(prefers-reduced-motion:reduce)');
      const controller = new AbortController();
      const signal = controller.signal;
      let index = 0, destination = 0, width = track.clientWidth, frame = 0, timer;
      const sync = () => {
        controls.hidden = !mobile.matches || cards.length < 2;
        if (mobile.matches) {
          const image = cards[index].querySelector(".caene-home-products__image");
          this.style.setProperty("--feed-image-height", `${image.getBoundingClientRect().height}px`);
        }
        cards.forEach((card, n) => { card.inert = mobile.matches && n !== index; });
        buttons[0].disabled = index === 0;
        buttons[1].disabled = index === cards.length - 1;
        const label = `${index + 1} / ${cards.length}`;
        if (count.textContent !== label) count.textContent = label;
      };
      const settle = () => {
        if (!mobile.matches) return;
        index = destination = Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
        sync();
      };
      const go = n => {
        if (!mobile.matches) return;
        destination = Math.max(0, Math.min(cards.length - 1, n));
        track.scrollTo({left: destination * track.clientWidth, behavior: motion.matches ? 'instant' : 'smooth'});
      };
      buttons.forEach(b => b.addEventListener('click', () => go(destination + Number(b.dataset.productStep)), {signal}));
      track.addEventListener('keydown', e => {
        if (e.target !== track || !mobile.matches) return;
        const n = e.key === 'ArrowRight' ? destination + 1 : e.key === 'ArrowLeft' ? destination - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? cards.length - 1 : null;
        if (n !== null) { e.preventDefault(); go(n); }
      }, {signal});
      track.addEventListener('scroll', () => { clearTimeout(timer); timer = setTimeout(settle, 120); }, {signal, passive:true});
      track.addEventListener('scrollend', settle, {signal});
      const measure = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          if (mobile.matches) {
            const header = document.querySelector('sticky-header');
            const h = header?.getBoundingClientRect().height || 0;
            const info = Math.max(...cards.map(c => c.querySelector('.caene-home-products__info').getBoundingClientRect().height));
            this.style.setProperty('--feed-header-height', `${Math.ceil(h)}px`);
            this.style.setProperty('--feed-info-height', `${Math.ceil(info)}px`);
            if (width !== track.clientWidth) { width = track.clientWidth; track.scrollTo({left:index * width, behavior:'instant'}); destination = index; }
          }
          sync();
        });
      };
      const resize = new ResizeObserver(measure);
      resize.observe(track);
      cards.forEach(c => resize.observe(c.querySelector('.caene-home-products__info')));
      const header = document.querySelector('sticky-header');
      if (header) resize.observe(header);
      mobile.addEventListener('change', measure, {signal});
      window.addEventListener('resize', measure, {signal});
      measure();
      this.cleanup = () => { controller.abort(); resize.disconnect(); clearTimeout(timer); cancelAnimationFrame(frame); cards.forEach(c => { c.inert = false; }); controls.hidden = true; };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
